import React from "react";

const CheckboxIndeterminate = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
        <path
            d="M3.5,6 L9,6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="square"
        />
    </svg>
);

export default CheckboxIndeterminate;
